import { FiCompass, FiUsers } from 'react-icons/fi';
import { LuSection } from 'react-icons/lu';

import { Link } from 'react-router-dom';
import '../styles/article.css';
import { useTranslation } from 'react-i18next';

interface Props {
  id: number;
  title: string;
  type: number;
  status: string;
  shortDescription: string;
  key: number;
}

const getIcon = ({ type }: { type: number }) => {
  switch (type) {
    case 1: {
      return <LuSection style={{ fontSize: '16px', color: '#98cb00' }} />;
    }
    case 2: {
      return <FiUsers style={{ fontSize: '16px', color: '#98cb00' }} />;
    }
    case 3: {
      return <FiCompass style={{ fontSize: '16px', color: '#98cb00' }} />;
    }
    default: {
      return;
    }
  }
};

export function ArticleCard({ id, title, type, status }: Props) {
  const { t } = useTranslation();
  const REG_TYPE_MAP: { 1: string; 2: string; 3: string } = {
    1: t('common.specification'),
    2: t('common.company-agreement'),
    3: t('common.implementation'),
  };
  return (
    <div className="article-card">
      <Link to={`/regulation/${id}`}>
        <div className="title">{title}</div>
      </Link>
      <div className="footer">
        <div className="type">
          {getIcon({ type })}
          {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment*/}
          {/* @ts-expect-error*/}
          {REG_TYPE_MAP[type]}
        </div>
        <div>
          {t('common.status')}: {status}
        </div>
      </div>
    </div>
  );
}
